 
import WebOffice from '../../../webOffice/index'; 

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name: '加班列表', path:''
            },{
                name:'加班详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/overtime/save',//保存
                bykey:'oa/official/overtime/byKey',//详情 
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editObj:{
                title:"",
                fileKey:"",
                userName:"",
                type:1,
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            overtimeWnd:false,
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件  
            fileNumList:[],
            WFtask:{}, 
            webShow: false,
            docFileKey:'',
            fileType:".docx"
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String, 
    },
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },               
    methods: {
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj = rsp.retObj; 
                    if(rsp.retObj.fileInfo){
                        me.fileList.push(rsp.retObj.fileInfo); 
                    }
                    me.$delete(me.editObj,'fileInfo'); 
                }
            })
        },
       
        goBack(){ 
            this.$router.go(-1);
        },
        handlePreview(file){ 
            if(file.path){
                if(file.path.includes(".docx")||file.path.includes(".xlsx")||file.path.includes(".doc")||file.path.includes(".xls")){
                    // this.docFileKey=file.id;
                    // this.fileType=file.path.substring(file.path.lastIndexOf("."),file.path.length);
                    // this.webShow=true;

                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.path.substring(file.path.lastIndexOf("."), file.path.length),
                            bizType:9,
                            fileId:file.id 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
              
                }else if(file.path.includes(".txt") ||file.path.includes(".pdf") || file.path.includes(".PDF") || file.path.includes(".png") || file.path.includes(".PNG")|| file.path.includes(".jgp") || file.path.includes(".JPG")|| file.path.includes(".gif") || file.path.includes(".GIF")){
                    const url = this.$global.baseUrl + file.path;
                    window.open(url, '_blank');
                } 
                else{
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.id;
                    window.open(url, '_blank');
                }
            } 
        },  
        print(){
            let {href}  = this.$router.resolve({ path: "/oa/official/overtime/print/"+this.key})
            window.open(href, '_blank')  
        },
        downloadFile(){
            if(this.fileList.length==1){
                const url = this.$global.baseUrl + 'sh/file/download?id=' +this.fileList[0].id;
                window.open(url, '_blank');
            }else{
                this.$message.error("没有上传附件!");
            }
           
        },
        callback(){
            
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/overtime/view/view.js